const UPDATE_STATE_INDEX = 'UPDATE_STATE_INDEX'
const UPDATE_STATE_SHOW = 'UPDATE_STATE_SHOW'


export {
  UPDATE_STATE_INDEX,
  UPDATE_STATE_SHOW
}